import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const radioDefaultVariants = {}
const radioCompoundVariants = []

const radioSlotNames = [
  [
    "container",
    "radio__container"
  ],
  [
    "input",
    "radio__input"
  ],
  [
    "indicator",
    "radio__indicator"
  ]
]
const radioSlotFns = /* @__PURE__ */ radioSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, radioDefaultVariants, getSlotCompoundVariant(radioCompoundVariants, slotName))])

const radioFn = memo((props = {}) => {
  return Object.fromEntries(radioSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const radioVariantKeys = []
const getVariantProps = (variants) => ({ ...radioDefaultVariants, ...compact(variants) })

export const radio = /* @__PURE__ */ Object.assign(radioFn, {
  __recipe__: false,
  __name__: 'radio',
  raw: (props) => props,
  classNameMap: {},
  variantKeys: radioVariantKeys,
  variantMap: {},
  splitVariantProps(props) {
    return splitProps(props, radioVariantKeys)
  },
  getVariantProps
})